import React from 'react';
import { NavLink } from 'react-router-dom';

import { Translate } from '../../../helpers/Translate';
// Reuses the quick-access tile styles from the Home page
import "../../Parent/parentpages/Home/Home.css";
import img12 from '../../../assets/reserved.png';
import img2 from '../../../assets/cafeteriamenu.png';

/**
 * Cafeteria landing page: links to meal reservations and to the
 * allowed-items menu.
 */
const Cafeteria = () => {
  const t = new Translate();

  return (
    <div className="content">
      <div className="pp-home-tiles">
        <NavLink className="pp-home-tile" to={"/dashboard/resturant"}>
          <div className="pp-home-tile-media">
            <img src={img12} alt="" />
          </div>
          <h2 className="pp-home-tile-title">{t.translate("Meals Reservations")}</h2>
        </NavLink>

        <NavLink className="pp-home-tile" to={"/dashboard/cafeteriamenu"}>
          <div className="pp-home-tile-media">
            <img src={img2} alt="" />
          </div>
          <h2 className="pp-home-tile-title">
            {t.translate("Cafeteria")} {t.translate("Menu")}
          </h2>
        </NavLink>
      </div>
    </div>
  );
};

export default Cafeteria;
